<div class="modal-header">
  <div class="modal-title">
    <h3 class="mb-0">{{ title || 'Update value' }}</h3>
    @if (message) {
      <p class="modal-subtitle mb-0">{{ message }}</p>
    }
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  <div class="form-group mb-0">
    <label class="form-label" for="gui-input">Value</label>
    <input
      id="gui-input"
      type="text"
      class="form-control"
      [(ngModel)]="inputValue"
    />
  </div>
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="cancel()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="continue()">
      Save
    </button>
  </div>
</div>
